// Interfaces
import { IBaseLabelProps, IBaseLabelRenderClassAttrs } from './interfaces'

const BaseLabel = ({ label, fontSize, isItalic, isBold, style, className, ...rest }: IBaseLabelProps) => {
  /**
   * @description Render class
   *
   * @param
   */
  const renderClass = ({ fontSize, isItalic, isBold }: IBaseLabelRenderClassAttrs): string => {
    const classes: string[] = []

    if (fontSize) classes.push(`font-${fontSize}`)
    if (isItalic) classes.push('font-italic')
    if (isBold) classes.push('font-bold')

    const join = classes.toString().split(',').join(' ')

    return join
  }

  return (
    <p
      style={{ ...style }}
      className={`${renderClass({ fontSize: fontSize || 11, isItalic, isBold })} ${className || ''}`}
      {...rest}
    >
      {label || '-'}
    </p>
  )
}

export { BaseLabel }
